import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-user-role-badge',
  templateUrl: './user-role-badge.component.html',
  styleUrls: ['./user-role-badge.component.scss']
})
export class UserRoleBadgeComponent implements OnInit {

  @Input()
  role: string;

  constructor() { }

  ngOnInit(): void {
  }

}
